import admin from '@/routes/admin';
import auth from '@/routes/auth';
import guest from '@/routes/guest';
import academy from '@/routes/academy';
import order from '@/routes/order';

export default [...auth, ...academy, ...order, ...admin, ...guest];



// WEBPACK FOOTER //
// ./src/routes/index.js